import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    // name: 'Home',
    // component: Home
    name: 'Board',
    component: () => import('../views/Board.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: 'about' */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/loginInit',
    name: 'LoginInit',
    component: () => import('../views/LoginInit.vue')
  },
  {
    path: '/UserInit',
    name: 'UserInit',
    component: () => import('../views/UserInit.vue')
  },
  {
    path: '/UserSelect',
    name: 'UserSelect',
    component: () => import('../views/pages/UserSelect.vue')
  },
  {
    path: '/Regist',
    name: 'Regist',
    component: () => import('../views/pages/UserRegist.vue')
  }
  // {
  //   path: '/board',
  //   name: 'Board',
  //   component: () => import('../views/Board.vue')
  // }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    if (!IDEContext.instance.isLogin) {
      next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
